import { Component, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {HeaderComponent} from "../../../common/header/header.component";
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-personal-information-finished',
    imports: [
        ColoredBackgroundComponent,
        FooterComponent,
        RouterLink,
        FinishBoxComponent,
        HeaderComponent,
    ],
  templateUrl: './personal-information-finished.component.html',
  styleUrl: './personal-information-finished.component.css'
})
export class PersonalInformationFinishedComponent {
  locale = inject(LocaleService);
}
